import { useEffect } from "react";
import { useLocation } from "react-router";
import { IntlProvider } from "react-intl";
import { useAppConfig } from "@ct-react/core";
import { defaultLocale, useLocaleContext } from "@ct-react/locale";
import LocaleRoutes from "./routes";
import { getIntlMessages } from "./i18n";
import { SearchProvider } from "./contexts/search";
import Header from "./components/layout/header";
import SearchBarIntoLayout from "./components/layout/search-bar-wrapper";
import { WishlistProvider } from "./contexts/wishlist";
import { useScrollAnimations } from "./hooks/scroll-animations";
import Footer from "./components/layout/footer";
import { Head } from "./components/layout/head";
import "./scss/global.scss";

const App = () => {

  const { id } = useAppConfig();
  const { locale } = useLocaleContext();
  const location = useLocation();

  useScrollAnimations();

  useEffect(() => {
    document.documentElement.lang = locale.code;
  }, [ locale ]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [ location.pathname ]);

  const IntlMessages = getIntlMessages(locale);

return (
  <IntlMessages>
    {({ default: messages }) => (
      <IntlProvider
        locale={locale.code}
        defaultLocale={defaultLocale.code}
        messages={messages}
      >
        <SearchProvider>
          <WishlistProvider>
            <Head>
              <meta property="og:locale" content={locale.code} />
              <meta property="og:type" content="website" />
              <meta property="og:site_name" content={id} />
            </Head>

            <Header />
            <SearchBarIntoLayout />

            <div className="main-wrap" role="main">
                <LocaleRoutes />
            </div>

            <Footer />
          </WishlistProvider>
        </SearchProvider>
      </IntlProvider>
    )}
  </IntlMessages>
);

}

export default App;
